import MyPosition from './container';

export default MyPosition;
